import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { 
  ChevronLeftIcon,
  TagIcon 
} from '@heroicons/react/24/outline';

const MegaMenu = ({ isOpen, onClose }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      fetchCategories();
    }
  }, [isOpen]);

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      
      const response = await axios.get('/api/categories', { headers });
      setCategories(response.data.allCategories || []);
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setLoading(false);
    }
  };

  const rootCategories = categories.filter(cat => !cat.parent_id && cat.is_active);
  const getSubcategories = (parentId) => {
    return categories.filter(cat => cat.parent_id === parentId && cat.is_active);
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 z-40"
        onClick={onClose}
      />

      {/* Simple Dropdown Menu */}
      <div className="absolute left-0 top-full mt-2 w-80 bg-white rounded-lg shadow-xl z-50 border border-gray-200 max-h-[80vh] overflow-y-auto">
        {loading ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
          </div>
        ) : (
          <div className="py-2">
            {/* View All Categories */}
            <Link
              to="/categories"
              onClick={onClose}
              className="block px-4 py-3 text-sm font-semibold text-indigo-600 hover:bg-indigo-50 border-b border-gray-100"
            >
              צפה בכל הקטגוריות
            </Link>

            {/* Categories List */}
            {rootCategories.map((category) => {
              const subcategories = getSubcategories(category.id);
              
              return (
                <div key={category.id} className="border-b border-gray-50 last:border-b-0">
                  {/* Main Category */}
                  <Link
                    to={`/categories/${category.slug}`}
                    onClick={onClose}
                    className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors group"
                  >
                    {category.image ? (
                      <img
                        src={category.image}
                        alt={category.name}
                        className="w-8 h-8 rounded object-cover flex-shrink-0"
                      />
                    ) : (
                      <div className="w-8 h-8 bg-gradient-to-br from-indigo-500 to-purple-600 rounded flex items-center justify-center flex-shrink-0">
                        <TagIcon className="h-4 w-4 text-white" />
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <div className="font-medium text-gray-900 truncate group-hover:text-indigo-600">
                        {category.name}
                      </div>
                      {category.name_en && (
                        <div className="text-xs text-gray-500 truncate">{category.name_en}</div>
                      )}
                    </div>
                    {subcategories.length > 0 && (
                      <ChevronLeftIcon className="h-4 w-4 text-gray-400 flex-shrink-0" />
                    )}
                  </Link>

                  {/* Subcategories (if any) */}
                  {subcategories.length > 0 && (
                    <div className="bg-gray-50 py-1">
                      {subcategories.slice(0, 5).map((subcat) => (
                        <Link
                          key={subcat.id}
                          to={`/categories/${subcat.slug}`}
                          onClick={onClose}
                          className="block px-12 py-2 text-sm text-gray-600 hover:text-indigo-600 hover:bg-white transition-colors"
                        >
                          {subcat.name}
                        </Link>
                      ))}
                      {subcategories.length > 5 && (
                        <Link
                          to={`/categories/${category.slug}`}
                          onClick={onClose}
                          className="block px-12 py-2 text-xs text-indigo-500 hover:text-indigo-700"
                        >
                          + עוד {subcategories.length - 5}
                        </Link>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default MegaMenu;